export const grcmDataSources = [
  {
    title: 'GRCM Knowledge Repository',
    content: `This knowledge repository is a centralized AI hub for GRCM **related documents, training materials, operating instructions, and process guidance**. Through **Akira's AI-powered search and knowledge capabilities**, users can quickly access how-to-do, understand GRCM processes, and find relevant guidance easily.`,
    sourceSystem: null,
    prompts: [
        'How to raise access request in GRCM?',
        'How can I raise a ticket in ServiceNow to get access to GRCM?',
        'How to create LPC in GRCM?',
        'How to create CAR in GRCM?',
        'How to Sign off CPCP Process in GRCM?',
        'How to Sign off TOC?',
        'How to Sign off Assurance Letter?',
        'How to create deficiency in GRCM?'
    ],
  }
]

/*
prompts for GRCM Knowledge Repository:
1.How to raise access request in GRCM?
2.How can I raise a ticket in ServiceNow to get access to GRCM.
3. How to create LPC in GRCM
4.How to create CAR in GRCM.
5.How to Sign off CPCP Process in GRCM.
6.How to Sign off TOC?
7.How to Sign off Assurance Letter?
8.How to create deficiency in GRCM.
 */